import { SectionOrSubSection } from 'approot/activity-builder/activity-builder.constants';
import { ComponentColumns } from '../component.constants';

export function getColumn(
  section: SectionOrSubSection,
  columnComponentId: string,
  columnId: string
) {
  const columnsComponent = section.components.find(
    comp => comp.id === columnComponentId
  ) as ComponentColumns;
  return columnsComponent.columns?.find(column => column.columnId === columnId);
}
